import React, { useState, useEffect} from "react";

const AuthContext = React.createContext();

function AuthComponent(props) {

  const [isLoggedIn, setLoggedIn] = useState(checkLoginStatus());
  const [session_data, setData] = useState(null);
  const [group_data, setGroupData] = useState(null);
  const [variables, setVariables] = useState([]);

  function checkLoginStatus() {
    return sessionStorage.getItem("isLoggedIn");
  }

  function getToken() {
    return sessionStorage.getItem("token");
  }

  function getGroupData() {
    return group_data;
  }

  function getGroupDataName(id) {
    let tmp = [];
    if (group_data) {
      tmp = group_data.filter((x) => {
        return x.id === id;
      });
    }

    if (tmp.length > 0) return tmp[0].name;
    else return "";
  }

  function getSessionData() {
    return session_data;
  }

  function setSessionData(x) {
    sessionStorage.setItem(
      "server-date",
      new Date(x.last_login).setHours(0, 0, 0, 0)
    );
    }
    
  function setToken(data) {
    sessionStorage.setItem("token", data.key);
  }

  function doLogin() {
    //console.log("Log in....");
    sessionStorage.setItem("isLoggedIn", true);
    setLoggedIn(true);
  }

  function doLogout() {
    //console.log("Log out....");
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("alumno");
    sessionStorage.removeItem("carreras");
    sessionStorage.removeItem("tiposdocumentos");
    sessionStorage.removeItem("pueblosoriginarios");
    sessionStorage.removeItem("localidades");
    sessionStorage.removeItem("localidades");
    sessionStorage.removeItem("provincias");
    sessionStorage.removeItem("identidadesgeneros");
    sessionStorage.removeItem("server-date");
    setLoggedIn(false);
  }

  function getVariable(key) {
    let variable = variables.find((x) => x.nombre === key);
    if (variable) {
      return variable.valor;
    }
    return undefined;
  }

  return (
    <AuthContext.Provider
      value={{
        doLogin,
        doLogout,
        getToken,
        setToken,
        isLoggedIn,
        checkLoginStatus,
        getSessionData,
        setSessionData,
        setGroupData,
        getGroupData,
        getGroupDataName,
        getVariable,
        setVariables,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthComponent };
